import React from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'components/common';

import { toggleModal } from 'data/actions/modals';
import { deleteSavedSearch } from 'data/actions/search';
import { modalsSelector, modalOptionsSelector } from 'data/selectors/modals';

import { ModalTitle, Label, CloseIcon, Footer } from '../baseModal/styles';

const DeleteSavedSearchModal = () => {
  const dispatch = useDispatch();
  const { visible } = useSelector(modalsSelector);
  const { savedSearchId, backModal, backOptions } = useSelector(modalOptionsSelector);

  const handleClose = () => {
    if (backModal) {
      dispatch(toggleModal(backModal, true, backOptions));
    } else {
      dispatch(toggleModal('delete_saved_search', false));
    }
  };
  const handleDelete = () => {
    dispatch(deleteSavedSearch(savedSearchId));
    handleClose();
  };

  return (
    <Modal
      visible={visible}
      title={
        <ModalTitle danger>
          Delete the saved search
          <CloseIcon onClick={handleClose} className="ic_close" />
        </ModalTitle>
      }
      closable={false}
      width={450}
      footer={false}
      onCancel={handleClose}
      closeIcon={<div />}
    >
      <>
        <Label>Delete the saved search? This action can&apos;t be undone. The saved search will be deleted.</Label>
      </>
      <Footer>
        <Button data-form="true" type="danger" size="large" onClick={handleDelete}>
          Delete
        </Button>
        <Button size="large" type="default" onClick={handleClose}>
          No
        </Button>
      </Footer>
    </Modal>
  );
};

export default DeleteSavedSearchModal;
